import { render, staticRenderFns } from "./ReadMoreContainer.vue?vue&type=template&id=f07d38ae&scoped=true"
import script from "./ReadMoreContainer.vue?vue&type=script&lang=js"
export * from "./ReadMoreContainer.vue?vue&type=script&lang=js"
import style0 from "./ReadMoreContainer.vue?vue&type=style&index=0&id=f07d38ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07d38ae",
  null
  
)

export default component.exports